<mat-form-field
  appearance="outline"
  class="form-field"
  [class.none-pointer-events]="!isEditModeActive()"
>
  <mat-label>Название файла</mat-label>
  <input
    matInput
    [(ngModel)]="file().fileName"
    (blur)="handleUpdateField('fileName')"
  >
</mat-form-field>
<app-file-card
  class="app-file-card"
  [fileCard]="{
    id: file().id,
    fileParams: file().file,
    fileType: listingEntityFileType(),
    isEditModeActive: isEditModeActive(),
    shouldCheckImageType: true
  }"
  [imgSize]="{
    width: '100%',
    height: '470px'
  }"
  [isNeedPreview]="true"
  [cardVariant]="'second'"
  (handleDelete)="handleDelete($event)"
/>
<mat-form-field
  appearance="outline"
  class="form-field"
  [class.none-pointer-events]="!isEditModeActive()"
>
  <mat-label>Название УТП</mat-label>
  <input
    matInput
    [(ngModel)]="file().usp"
    (blur)="handleUpdateField('usp')"
  >
</mat-form-field>
<app-custom-mat-select
  #customSelect
  [selectedValueId]="selectedUspPriority()"
  [label]="'Приоритет УТП'"
  [options]="uspPrioritySelectData"
  [fullWidth]="true"
  [needEmptyValue]="false"
  (selectedChange)="handleUpdateUspPriority($event)"
/>
